"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/providers/locale/use-locale-context.ts
var [LocaleContextProvider, useLocaleContext] = createContext({
	name: "LocaleContext",
	hookName: "useLocaleContext",
	providerName: "<LocaleProvider />",
	strict: false,
	defaultValue: {
		dir: "ltr",
		locale: "en-US"
	}
});
//#endregion
export { LocaleContextProvider, useLocaleContext };
